module.exports = __webpack_public_path__ + "img/gather_sleeve_ruffle.2ddd1654.png";